module.exports = __webpack_public_path__ + "img/cart.c986d7e2.svg";